var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcecream5Nd69K2Ouf5K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 396.997 396.997",
    viewBox: "0 0 396.997 396.997",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.099,
    x2: 249.295,
    y1: 38.596,
    y2: 125.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c5e56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685356"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0027,
    stopColor: "#f9eeda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3188,
    stopColor: "#faead6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6448,
    stopColor: "#fcdec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9742,
    stopColor: "#ffcab5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc8b3"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.685,
    x2: 322.747,
    xlinkHref: "#lg1",
    y1: 107.673,
    y2: 201.407
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc1a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2719,
    stopColor: "#ffb09f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8055,
    stopColor: "#ff8584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7479"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.17,
    x2: 231.219,
    xlinkHref: "#lg2",
    y1: 91.258,
    y2: 193.324
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.222,
    x2: 320.284,
    xlinkHref: "#lg1",
    y1: 111.013,
    y2: 204.747
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.275,
    x2: 337.5,
    y1: 157.608,
    y2: 326.531
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd4aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#ffcb97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8387,
    stopColor: "#ffb366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffab57"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.391,
    x2: 225.44,
    xlinkHref: "#lg2",
    y1: 102.699,
    y2: 204.765
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 525.227,
    x2: 545.949,
    xlinkHref: "#lg2",
    y1: 784.685,
    y2: 835.998
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.289,
    x2: 471.011,
    xlinkHref: "#lg2",
    y1: 814.948,
    y2: 866.261
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.607,
    x2: 502.329,
    xlinkHref: "#lg2",
    y1: 802.3,
    y2: 853.613
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 196.19,
    cy: 81.494,
    fill: "url(#SVGID_1_)",
    r: 81.494
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.444,
    cy: 149.544,
    fill: "url(#SVGID_2_)",
    r: 81.494
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 144.553,
    cy: 149.544,
    fill: "url(#SVGID_3_)",
    r: 81.494
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.104 169.183h158.681c7.965 0 14.482-6.517 14.482-14.482 0-7.965-6.517-14.482-14.482-14.482h-158.681c-7.965 0-14.482 6.517-14.482 14.482-.001 7.965 6.516 14.482 14.482 14.482z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.036 169.38-135.846 227.617-135.847-227.617z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f9e9d7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.631 206.724 53.333-37.344h-10.461l-45.955 32.178z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.078 237.633 97.475-68.253h-10.461l-90.097 63.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.525 268.542 141.618-99.162h-10.461l-134.24 93.996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.889 294.284 3.083 5.166 185.759-130.07h-10.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.419 330.359 136.645-95.68 7.51-12.583-147.238 103.097z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.866 361.268 73.265-51.301 7.51-12.583-83.858 58.718z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m238.375 154.701c0-7.965-6.517-14.482-14.482-14.482h-158.681c-7.965 0-14.482 6.517-14.482 14.482 0 7.965 6.517 14.482 14.482 14.482h90.743c4.968 0 8.995 4.027 8.995 8.995v49.102c0 7.462 5.735 13.884 13.189 14.235 7.959.375 14.529-5.967 14.529-13.843v-49.493c0-4.968 4.027-8.995 8.995-8.995 4.968 0 8.995 4.027 8.995 8.995v76.088c0 7.654 6.205 13.859 13.859 13.859 7.654 0 13.859-6.205 13.859-13.859v-99.457h-.005c-.001-.037.004-.072.004-.109z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.251 24.753h23.099v9h-23.099z",
    fill: "#dd455b",
    transform: "matrix(.713 .702 -.702 .713 81.083 -139.466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m251.681 106.077-16.462-16.203 6.313-6.414 16.462 16.203z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.793 114.179-16.463-16.203 6.314-6.414 16.463 16.202z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.285 93.732h9v23.099h-9z",
    fill: "#dd455b",
    transform: "matrix(.713 .702 -.702 .713 155.968 -170.227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.174 52.532-6.313-6.415 16.462-16.203 6.314 6.414z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.427 83.09h9v23.099h-9z",
    fill: "#a1cad5",
    transform: "matrix(.702 .713 -.713 .702 104.141 -59.357)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcecream5Nd69K2Ouf5K);
export default __webpack_public_path__ + "static/media/icecream_5nd69k2ouf5k.7523cad99a9856ce5c757caebb94150b.svg";
export { ForwardRef as ReactComponent };